import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule, EllipsisPipe } from "@caseworthy/cw-ui-components";
import { PopupMessageModalModule } from "./modals/popup-message-modal/popup-message-modal.module";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { ToastrModule } from "ngx-toastr";
import { ConfirmationDialogBoxComponent } from "./modals/confirmation-dialog-box/confirmation-dialog-box.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTableModule } from "@angular/material/table";
import { MatListModule } from "@angular/material/list";
import { MatExpansionModule } from "@angular/material/expansion";
import {MatSidenavModule} from '@angular/material/sidenav';
import { MainScreenLoaderComponent } from "./components/main-screen-loader/main-screen-loader.component";
import { GroupByPipe } from "./pipes/group-by.pipe";

@NgModule({
  declarations: [ConfirmationDialogBoxComponent, MainScreenLoaderComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PopupMessageModalModule,
    MatFormFieldModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatSnackBarModule,
    MatDividerModule,
    MatInputModule,
    MatGridListModule,
    ToastrModule.forRoot(),
    ComponentsModule,
    DatePipe,
    MatTooltipModule,
    MatCheckboxModule,
    DragDropModule,
    MatTableModule,
    MatListModule,
    MatSidenavModule,
    MatExpansionModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    PopupMessageModalModule,
    MatFormFieldModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatSnackBarModule,
    MatDividerModule,
    MatInputModule,
    MatGridListModule,
    ComponentsModule,
    ToastrModule,
    DatePipe,
    ConfirmationDialogBoxComponent,
    MatTooltipModule,
    MatCheckboxModule,
    DragDropModule,
    MatTableModule,
    MatListModule,
    MatSidenavModule,
    MainScreenLoaderComponent,
    MatExpansionModule,
  ],
  providers: [DatePipe, EllipsisPipe, GroupByPipe]
})
export class SharedModule {}
